import { useReducedMotion } from 'framer-motion'
import { TICKER_ITEMS } from '../../../data'

const TICKER_ICONS: Record<string, React.ReactNode> = {
  reply: (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M9 4l-6 6 6 6V12.5c4.5 0 7.5 1.8 9 5.5-1-7-6-10-9-10V4z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  ),
  booking: (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden>
      <rect x="3.5" y="5" width="17" height="15" rx="2.5" stroke="currentColor" strokeWidth="2" />
      <path d="M3.5 10h17M8 3v4M16 3v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  ),
  spark: (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M12 3l1.7 5.6 5.8 1.6-5.8 1.6L12 17.4l-1.7-5.6L4.5 10.2 10.3 8.6 12 3z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  ),
}

function iconForLabel(label: string) {
  const l = label.toLowerCase()
  if (l.includes('reply')) return TICKER_ICONS.reply
  if (l.includes('book') || l.includes('appointment') || l.includes('membership')) return TICKER_ICONS.booking
  return TICKER_ICONS.spark
}

export default function TickerSection() {
  const shouldReduceMotion = useReducedMotion()

  return (
    <div
      className="overflow-hidden group relative"
      style={{
        backgroundColor: '#111',
        color: '#FBE6D4',
        padding: '14px 0',
      }}
      aria-label="Live re-engagement updates"
    >
      <div
        className="flex gap-3 whitespace-nowrap"
        style={{
          animation: shouldReduceMotion ? 'none' : 'nudge-ticker-scroll 40s linear infinite',
        }}
      >
        <style>{`
          @keyframes nudge-ticker-scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .group:hover > div {
            animation-play-state: paused;
          }
        `}</style>
        {[...TICKER_ITEMS, ...TICKER_ITEMS].map((item, i) => (
          <span
            key={`${item.label}-${i}`}
            className="inline-flex items-center gap-2 flex-shrink-0 text-sm"
            style={{
              color: '#FBE6D4',
              padding: '4px 20px',
              borderRight: '1px solid rgba(251,230,212,0.15)',
            }}
          >
            <span style={{ color: 'var(--accent)', display: 'inline-flex' }}>
              {iconForLabel(item.label)}
            </span>
            <span
              className="font-dm-mono font-bold uppercase"
              style={{ color: 'var(--accent)', fontSize: '0.72rem', letterSpacing: '0.08em' }}
            >
              {item.label}
            </span>
            <span style={{ color: '#FBE6D4', opacity: 0.85 }}>{item.text}</span>
          </span>
        ))}
      </div>
    </div>
  )
}
